import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash.get';
import { pageTypeConstants as pageTypes } from '../../constants/pageTypeConstants';
import { trackEcommerce, trackEvent } from 'dibs-tracking';
import { getCategories } from '../../utils/categoryHelpers';
import { createFragmentContainer, graphql } from 'react-relay';
import { ECOMMERCE_ATTRIBUTES } from '../../constants/attributesConstants';

class SbSharedCategoryTilesTrackingComponent extends React.Component {
    constructor() {
        super();

        this.fireTracking = this.fireTracking.bind(this);
        this.trackClick = this.trackClick.bind(this);
    }

    componentDidMount() {
        this.fireTracking();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.itemSearch.displayUriRef !== this.props.itemSearch.displayUriRef) {
            this.fireTracking();
        }
    }

    fireTracking() {
        const { itemSearch, pageLevel } = this.props;

        if (itemSearch.pageType === pageTypes.SEARCH) {
            trackEvent({
                category: 'promo interaction',
                action: 'broad search tiles displayed',
                label: `l${pageLevel}`,
            });
        } else {
            trackEcommerce({
                type: 'promotionImpression',
                promotions: this.getTrendingPromotions(),
            });
        }
    }

    trackClick(index) {
        const { pageLevel, itemSearch } = this.props;

        if (itemSearch.pageType === pageTypes.SEARCH) {
            trackEvent({
                category: 'promo interaction',
                action: 'broad search tiles clicked',
                label: `l${pageLevel}`,
            });
        } else {
            const promotions = this.getTrendingPromotions();
            trackEcommerce({
                type: 'promoClick',
                promotions: [promotions[index]],
            });
        }
    }

    getTrendingPromotions() {
        const { itemSearch, pageLevel, maxTilesAllowed } = this.props;
        const { appliedFilters = [], categoryTiles } = itemSearch;

        let tiles = categoryTiles || [];
        tiles = maxTilesAllowed ? categoryTiles.slice(0, maxTilesAllowed) : categoryTiles;

        const attributes = appliedFilters.filter(({ name }) => ECOMMERCE_ATTRIBUTES.includes(name));
        let trackingId = `L${pageLevel + 1}`;
        let trackingNameType = 'Result';

        if (attributes.length) {
            const attributeName = get(attributes, '[0].name');
            const attributeValue = get(attributes, '[0].values[0].urlLabel');
            trackingId =
                attributes.length > 1 ? 'multi-attribute' : `${attributeName}:${attributeValue}`;
            trackingNameType = 'Attribute';
        }

        return tiles.map((tile, i) => ({
            creative: tile.displayName,
            id: `${trackingId}-result-tiles`,
            name: `L${pageLevel}|${trackingNameType} Tiles`,
            position: i + 1,
            itemId: tile.itemId,
        }));
    }

    render() {
        const { trackClick } = this;
        return this.props.children({ trackClick });
    }
}

SbSharedCategoryTilesTrackingComponent.propTypes = {
    pageLevel: PropTypes.number,
    maxTilesAllowed: PropTypes.number,
    children: PropTypes.func.isRequired,
    itemSearch: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    const appliedFilters = state.filters.appliedFilters;
    const categories = getCategories(appliedFilters);

    return {
        pageLevel: categories.length,
    };
}

export const SbSharedCategoryTilesTracking = createFragmentContainer(
    connect(mapStateToProps)(SbSharedCategoryTilesTrackingComponent),
    {
        itemSearch: graphql`
            fragment SbSharedCategoryTilesTracking_itemSearch on ItemSearchQueryConnection {
                displayUriRef
                pageType
                categoryTiles {
                    displayName
                    itemId
                }
                appliedFilters {
                    name
                    values {
                        urlLabel
                    }
                }
            }
        `,
    }
);
